<div class="login-container">
    <h2>Admin Bejelentkezés</h2>
    <form (ngSubmit)="login()">
      <input type="email" [(ngModel)]="email" name="email" placeholder="Email" required />
      <input type="password" [(ngModel)]="password" name="password" placeholder="Jelszó" required />
      <button type="submit" [disabled]="!email || !password">Bejelentkezés</button>
    </form>
    <div class="error-message" *ngIf="error">{{ error }}</div>
  </div>
  